import { LoadingButton } from "@mui/lab";
import {
	Button,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
} from "@mui/material";
import { type Dispatch, type SetStateAction } from "react";
import { useApiMutation } from "src/hooks/useApiMutation";

interface Props {
	setProductStatus: Dispatch<SetStateAction<string>>;
	status: string;
	id: number;
	closeModal: () => void;
}

const EditProduct = ({ status, setProductStatus, id, closeModal }: Props) => {
	const { mutate: updateProduct, isPending } = useApiMutation<
		{ status: string },
		void
	>({
		method: "PATCH",
		endPoint: `/api/fair/products/for-admin/${id}`,
		invalidateQueries: ["Products"],
	});

	return (
		<div style={{ width: "100%" }}>
			<FormControl
				required
				margin="normal"
				sx={{ width: "100%", minWidth: "150px" }}
			>
				<InputLabel required id="select-status">
					Status
				</InputLabel>
				<Select
					labelId="select-status"
					id="demo-simple-select"
					value={status}
					label="Status"
					required
					onChange={(e) => {
						setProductStatus(e.target.value);
					}}
				>
					<MenuItem value="approved">Approved</MenuItem>
					<MenuItem value="pending">Pending</MenuItem>
					<MenuItem value="rejected">Rejected</MenuItem>
				</Select>
				{!isPending ? (
					<Button
						onClick={() => {
							updateProduct({ status });
							closeModal();
						}}
						type="submit"
						fullWidth
						variant="contained"
						disableElevation
						sx={{
							mt: 3,
							mb: 2,
							py: 1,
						}}
					>
						Update status
					</Button>
				) : (
					<LoadingButton
						loading
						fullWidth
						loadingIndicator="Updating..."
						variant="outlined"
						disableElevation
						sx={{
							mt: 3,
							mb: 2,
							py: 1,
						}}
					>
						Updating...
					</LoadingButton>
				)}
			</FormControl>
		</div>
	);
};

export default EditProduct;
